var map = {
	"./FrenchPress.json": 1684,
	"./HarioSwitch.json": 7209,
	"./IcedFilterCoffee.json": 6189,
	"./OneCupV60.json": 9944,
	"./OrigamiMedina.json": 7709,
	"./TetsuKasuyaV60.json": 9001,
	"./TheUltimateV60.json": 1901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4229;